<template>
    <div>
      <b-sidebar
        id="sidebar-right"
        :backdrop-variant="variant"
        backdrop
        no-header
        right
        shadow
      >
        <!-- <template #default="{hide}"> -->
  
        <div
          class="w-100 h-100"
        >
        <Grid
          :data-items="audit"
          id="grid"
          :pageable="pageable"
          :total="total"
          :columns="columns"
          :resizable="true" 
          :skip="skip"
          :take="take"
          :sort="sort"
          @pagechange="pageChangeHandler"
          ref="auditGrid"
          class="w-100 h-100"
          
        >
        <grid-toolbar>
              <div class="d-flex">
                <div class="mr-auto">
                  <h2 class="ml-1" id="sidebar-no-header-title">
                    <span style="font-size: 16px" class="nt-clock"></span>
                    Device History
                  </h2>
                </div>
              </div>
            </grid-toolbar>
        </Grid>
        </div>
      </b-sidebar>
    </div>
  </template>
  
  <script>
  // import { mapState } from "vuex";
  import { createNamespacedHelpers } from "vuex";
  const { mapState } = createNamespacedHelpers("device");
  import { formatAMPMTime, formatTime } from "@/utils/date-helpers";
  import { BSidebar } from "bootstrap-vue";
  import { Grid } from "@progress/kendo-vue-grid";
  import moment from "moment-timezone";

  
  
  export default {
    components: {
      BSidebar,
      Grid
    },
    props: {
      audit: Array,
      currentPage: {
        default: 1,
        type: Number,
      },
      totalRows: {
        default: 10,
        type: Number,
      },
      perPage: {
        default: 4,
        type: Number,
      },
    },
    methods: {
      getTime: function (h, tdElement, props) {
        const field = props.field;
        var value = props.dataItem[field];
        if (!value) {
          return h("td", {}, "");
        }
        if (value) {
          let date;
          if (value.charAt(value.length - 1) === "Z") {
            date = value;
          } else {
            date = value + "Z";
          }
          let val = this.isTimeformat
            ? formatTime(new Date(date))
            : formatAMPMTime(new Date(date));
          return h("td", {}, val);
        }
      },
      getDate: function(h, tdElement, props) {
      let date = props.dataItem[props.field];
      if (date) {
        if (date.charAt(date.length - 1) === 'Z') {
          date = moment(date).format("MM/DD/YYYY");
        } else {
          date = moment(date + 'Z').format("MM/DD/YYYY");
        }
      }
      return h("td", {}, date ? date.toString() : "");
    },
    sensors: function (h, tdElement, props) {
      const field = props.field;
      var value = props.dataItem[field];
      if (!value) {
        return h("td", {}, "");
      }
      let arrayValue =  Array.isArray(value)?value:value.split(',')
      const numArr = arrayValue ? arrayValue : [];
      if(this.initialData.sensors) {
        const arr = this.initialData.sensors.filter((dev) =>{ 
        return numArr.includes(dev.id + '');
      });
      const names = arr.map(a => a.name).join(',');
      return h("td", {}, names ? names : numArr.join(','));
      }
      
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    },
    data: function() {
      return {
        variant: "light",
        skip: 0,
        take: 4,
        pageable: {
          previousNext: true,
          pageSize: 4,
          pageSizes: false,
          buttonCount: 6
        },
        staticColumns: [
          // { field: "action", title: "Activity Log", cell: "commonTemplate", headerCell: "commonHeadCell"},
      ],
      sort: [{ field: "actionType", dir: "asc" }],
      columns: [
        {
          hidden: false,
          field: "tenantName",
          title: "Tenant Name",
          width: "120px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          field: "vehicleRtoNumber",
          title: "Vehicle Number",
          width: "150px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          field: "startDate",
          title: "Start Date",
          // width: "200px",
          checked: true,
          defaultSelected: false,
        },
        {
          hidden: false,
          field: "endDate",
          title: "End Date",
          // width: "200px",
          checked: true,
          defaultSelected: false,
        },
        {
          hidden: false,
          field: "sensors",
          title: "Sensors",
          // width: "200px",
          cell:this.sensors,
          checked: true,
          defaultSelected: false,
        },
      ],
      };
    },
    watch: {
      currentPage: function(newVal) {
        this.$emit("changeCurrentPage", newVal);
      },
    },
    computed:{
      ...mapState(["initialData"]),
       total() {
      return this.audit ? this.audit.length: 0;
    },
    },
    
  };
  </script>
  
  <style scoped>
  .card-style {
    width: 100%;
    background: white;
    color: #6e6c68;
    min-height: 100px;
    padding: 10px;
    margin-bottom: 10px;
  }
  ::v-deep .b-sidebar{
    width: 600px  !important;
  }
  .rd-item {
    border-radius: 4px;
    padding: 7px 8px;
    background-color: #fff;
    margin-right: 5px;
    color: #004085;
    font-size: 12px;
    line-height: 1;
  }
  span.rd-badge {
    padding: 0px 5px;
    background: #0047b2;
    border-radius: 5px;
    color: #ffffff;
    line-height: 1;
    font-size: 11px;
    margin-left: 4px;
  }
  ::v-deep .b-sidebar-body {
    overflow-y: unset !important;
  }
  .b-sidebar-header {
    z-index: 100;
  }
  </style>
  